import DocStyleTemplatesDropdown from "components/DocStyleTemplatesDropdown";
import { func, string } from "prop-types";

const StyleTemplatePicker = ({
  onChangeTemplateId,
  onTemplateError,
  templateError,
}) => {
  const onSelectTemplate = (id) => {
    onTemplateError(undefined);
    onChangeTemplateId(id);
  };

  return (
    <>
      <h4>Choose your Style Template</h4>
      <p>Choose the styles which work best for this document.</p>

      <DocStyleTemplatesDropdown
        error={templateError}
        onSelect={onSelectTemplate}
      />
    </>
  );
};

StyleTemplatePicker.propTypes = {
  onChangeTemplateId: func.isRequired,
  onTemplateError: func.isRequired,
  templateError: string,
};

export default StyleTemplatePicker;
